<template>
  <div>
    <b-modal :id="modalData.id" :title="modalData.title">
      {{modalData.text}}
      <b-select v-model="modalData.selectedId">
        <option
          v-for="program in modalData.programs"
          :key="modalData.id + '-' + program.id"
          :value="program.id"
        >{{program.name}}</option>
      </b-select>
      <template v-slot:modal-footer>
        <b-button
          size="sm"
          variant="info"
          @click="confirm()"
          :disabled="modalData.selectedId ? false : true"
        >{{modalData.confirmText}}</b-button>
        <b-button size="sm" variant="outline-info" @click="hide()">{{modalData.cancelText}}</b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
export default {
  data() {
    return {
      modalData: {
        id: "",
        title: "",
        programs: [],
        selectedId: "",
        onConfirm: {},
        confirmText: "",
        cancelText: ""
      }
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide(this.modalData.id);
    },
    confirm() {
      // we must check if this.onConfirm is function
      if (typeof this.modalData.onConfirm === "function") {
        // run passed function and then close the modal
        let close = this.modalData.onConfirm(this.modalData.selectedId);
        if (close) {
          this.$bvModal.hide(this.modalData.id);
        }
      }
    },
    show(params) {
      // setting title and text
      this.modalData = params;
      this.$nextTick(function () {
        this.$bvModal.show(this.modalData.id);
      });
    }
  }
};
</script>